<form [formGroup]="form">
  <div class="apm-card-content d-flex flex-column">
    <div class="row mb-3">
      <div class="col-12">
        <label for="title">{{ '444844' | apmTranslate }}</label>
        <input class="apm-input" id="title" type="text" formControlName="title" />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-6">
        <label for="status">{{ '444845' | apmTranslate }}</label>
        <ng-container *ngIf="statuses$ | async as statuses">
          <apm-select
            id="status"
            [clearable]="false"
            [items]="statuses"
            formControlName="status"
            bindLabel="description"
            bindValue="code"
          >
          </apm-select>
        </ng-container>
      </div>
      <div class="col-6">
        <label for="image">{{ '444846' | apmTranslate }}</label>
        <apm-file-input
          id="image"
          [showInput]="true"
          [disabled]="uploadFileDisabled"
          formControlName="image"
          acceptedFile="image/*"
        ></apm-file-input>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-6">
        <label for="publishDate">{{ '444848' | apmTranslate }}</label>
        <apm-datepicker id="publishDate" [withTime]="true" formControlName="publishDate"></apm-datepicker>
      </div>
      <div class="col-6">
        <label for="expiringDate">{{ '444849' | apmTranslate }}</label>
        <apm-datepicker id="expiringDate" formControlName="expiringDate"></apm-datepicker>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-12">
        <apm-section-title title="{{ '444823' | apmTranslate }}" icon="t_assign"></apm-section-title>
        <apm-autocomplete
          [searchFn]="getTags"
          [multiple]="true"
          [addTag]="addTag"
          [clearable]="true"
          [minLengthTerm]="1"
          [bindLabel]="'value'"
          formControlName="tags"
        >
        </apm-autocomplete>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-12">
        <label>{{ '444847' | apmTranslate }}</label>
        <apm-editor *ngIf="showCkEditor()" [form]="fc.content"></apm-editor>
      </div>
    </div>
  </div>
</form>
